import { hideModal, showModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { useContext, useEffect, useState } from "react";
import SalirIconDrop from "_+_Portal/assets/images/generico/SalirIconDrop";
import { PortalContext } from "_+_Portal/context/Provider";
import TurnoSinRecepcion from "_+_Portal/_-_Autocheckin/components/genericos/TurnoSinRecepcion/TurnoSinRecepcion";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { wsGetTurnosPacienteDelDia } from "_+_Portal/_-_Autocheckin/context/action/turnosAutoCheckIn";
import { setTurnosSeleccionado } from "_+_Portal/_-_Autocheckin/context/action/turnosSeleccionados";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import CardAguardar from "../../components/genericos/CardAguardar/CardAguardar";
import LayoutPasos from "../../components/genericos/LayoutPasos/LayoutPasos";
import { isPendiente } from "../PagesFun";

import {
  BtnColaVirtual,
  ContainerCardRecep,
  ContainerTurnosRecep,
  ContenidoPendiente,
} from "./localStyle";

const TurnosRecepcionados = ({ turnoActual, setLoading }) => {
  const {
    turnosSeleccionadosState,
    turnosRecepcionadosState,
    turnosAutoCheckInState,
    turnosSeleccionadosDispatch,
    pasoDispatch,
    turnosAutoCheckInDispatch,
  } = useContext(AutocheckContext);
  const { selectDropDownState } = useContext(PortalContext);

  const { modalDispatch } = useContext(GlobalContext);
  let parsedConfig = {};
  try { parsedConfig = JSON.parse(localStorage.getItem("config")) || {}; } catch (e) { parsedConfig = {}; }
  let opcFilaVirtual = parsedConfig.opcFilaVirtual;

  // -------------------------  constantes ----------------------------

  let listaTurnosCompleta = turnosAutoCheckInState.turnosAutoCheckIn?.data ?? [];
  listaTurnosCompleta = listaTurnosCompleta.filter((element) => {
    if (!element?.checkin || element?.idProtocolo) {
      return false;
    } else if (element?.ausente && !element?.presente) {
      return false;
    } else return true;
  });
  const listaTurnos = turnosRecepcionadosState.turnosRecepcionados?.data ?? [];

  const idPacFamiliar = selectDropDownState.selectDropDown.selectGlobal
    .pacienteElegido?.paciente?.codigo
    ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido?.paciente
        ?.codigo
    : false;
  // -------------------------  constantes ----------------------------

  const [len, setLen] = useState(0);
  const [select, setSelect] = useState(listaTurnos.length === 1 ? 0 : false);

  const handleClick = () => {
    setTurnosSeleccionado(listaTurnos[0])(turnosSeleccionadosDispatch);
    setPaso("DemoraPaciente")(pasoDispatch);
  };
  const VerTurnosRecepcionados = () => {
    setSelect(false);
    setLen(0);
  };

  const recepcionarme = () => {
    const nexsStep = (isCorrect, data) => {
      setPaso("TurnosDelDia")(pasoDispatch);
    };
    setLoading("Cargando turnos del día...");
    wsGetTurnosPacienteDelDia(
      idPacFamiliar,
      nexsStep,
    )(turnosAutoCheckInDispatch);
    // setPaso("TurnosDelDia")(pasoDispatch);
    hideModal()(modalDispatch);
  };

  const salirSinRecepcion = () => {
    hideModal()(modalDispatch);
  };

  useEffect(() => {
    if (isPendiente(listaTurnosCompleta, listaTurnos)) {
      showModal(
        <TurnoSinRecepcion
          title={"Turnos sin recepcionar"}
          desc="Cuenta con otros turnos para el día de hoy sin recepcionar."
          textBtnOne={"Salir sin recepcionar"}
          textBtnTwo="Recepcionarme"
          handleClick={{
            btnTwoClick: recepcionarme,
            btnOneClick: salirSinRecepcion,
          }}
        />,
      )(modalDispatch);
    }
  }, []);

  return (
    <LayoutPasos volverTo={"/autocheckin"} title={"Turnos recepcionados"}>
      <ContainerTurnosRecep
        initial={{ opacity: 0, y: +100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        {len === 0 ? (
          <>
            {/* <h1>Turnos recepcionados</h1> */}
            {isPendiente(listaTurnosCompleta, listaTurnos) && (
              <ContenidoPendiente>
                <span>{"Tiene turnos para recepcionar."}</span>
                <button className="turnos" onClick={recepcionarme}>
                  <SalirIconDrop color={"var(--color-white)"} />
                  Ver turnos pendientes
                </button>
              </ContenidoPendiente>
            )}
          </>
        ) : (
          ""
        )}
        {opcFilaVirtual && (
          <BtnColaVirtual className="rb18b" onClick={handleClick}>
            Ver cola virtual
          </BtnColaVirtual>
        )}

        <ContainerCardRecep>
          {listaTurnos.map((element, key) => {
            if (!select && len !== 1)
              return (
                <CardAguardar
                  horaTurno={element.hora}
                  nombreTurno={element.especialidad}
                  sedeTurno={element.centro}
                  flgSoloConsulta={element.flgSoloConsulta}
                  medico={element.medico}
                  consultorioTurno={
                    !element?.consultorio ? "" : element?.consultorio
                  }
                  btnDisable={len === 1}
                  handleClick={() => {}}
                  key={key}
                  index={key}
                />
              );
            if (select === key) {
              return (
                <CardAguardar
                  horaTurno={element.hora}
                  nombreTurno={element.especialidad}
                  sedeTurno={element.centro}
                  flgSoloConsulta={element.flgSoloConsulta}
                  medico={element.medico}
                  consultorioTurno={
                    !element?.consultorio ? "" : element?.consultorio
                  }
                  btnDisable={len === 1}
                  key={key}
                  handleClick={() => {}}
                />
              );
            }
          })}
          {len === 1 && (
            <>
              <button className="turnos" onClick={VerTurnosRecepcionados}>
                Ver Turnos recepcionados
              </button>
              <div
                className="message"
                dangerouslySetInnerHTML={{
                  __html: `Vemos que ya se anunció. <br/>
                          Le pedimos que aguarde a ser llamado.`,
                }}
              />
            </>
          )}
        </ContainerCardRecep>
      </ContainerTurnosRecep>
    </LayoutPasos>
  );
};

export default TurnosRecepcionados;
